import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const COLORS = {
    consulta: '#10b981',
    receta: '#3b82f6',
};

export function IngresosBreakdown({ porConsulta, porRecetas }) {
    const data = [
        {
            name: 'Consultas',
            value: porConsulta,
            color: COLORS.consulta,
        },
        {
            name: 'Recetas',
            value: porRecetas,
            color: COLORS.receta,
        },
    ];

    return (
        <div
            style={{
                backgroundColor: '#ffffff',
                borderRadius: 12,
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                padding: 24,
                margin: 15,
            }}
        >
            <h3
                style={{
                    fontWeight: 600,
                    color: '#111827',
                    marginBottom: 16,
                }}
            >
                Ingresos por Tipo
            </h3>

            <div style={{ height: 300 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) =>
                                `${name}: ${(percent * 100).toFixed(0)}%`
                            }
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>

                        <Tooltip
                            formatter={(value) =>
                                `$${value.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                })}`
                            }
                            contentStyle={{
                                backgroundColor: '#fff',
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                            }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div
                style={{
                    marginTop: 16,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                }}
            >
                {data.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            fontSize: 14,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                            }}
                        >
                            <div
                                style={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: '50%',
                                    backgroundColor: item.color,
                                }}
                            />
                            <span style={{ color: '#374151' }}>{item.name}</span>
                        </div>

                        <span
                            style={{
                                color: '#111827',
                                fontWeight: 500,
                            }}
                        >
                            $
                            {item.value.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                            })}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}